


































import { Component, Prop, Vue } from 'vue-property-decorator';
import PublicQuestionContainer from '@/components/public-questions/PublicQuestionContainer.vue';
import { Question } from '@/resource/question/question.model';

@Component({
  components: {
    PublicQuestionContainer,
  },
})
export default class UploadQuestionPreview extends Vue {
  @Prop()
  objectives!: Question[];

  @Prop()
  subjectives!: Question[];
}
